<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-01-10 11:27:41
 * @FilePath: /wemeet-admin-new/src/views/brand/components/setCategoryGroup.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="formRef" :model="form" :rules="rules">
      <el-form-item label="机构名称">
        <el-input v-model="exhibitorName" disabled />
      </el-form-item>
      <el-form-item label="设置类目" />

      <el-form-item v-for="(item, index) in allCategoryList" :key="index" :label="item.name" :prop="item.prop">
        <el-select v-model="form[item.prop]" multiple>
          <el-option
            v-for="sitem in item.exhibitorSearchCategoryConfigVos"
            :key="sitem.id"
            :label="sitem.name"
            :value="sitem.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { queryCategoryConfigList, addOrUpdateExhibitorCategory, queryExhibitorCategory } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      groupId: {
        type: Number,
        default: '',
      },
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '30%',
        title: '',
        form: {
          name: '',
        },
        rules: {},
        checkUserList: [],
        allCategoryList: [],
        formRef: null,
        enterpriseId: '',
        exhibitorName: '',
      })
      // 打开
      const handleOpen = async (row) => {
        state.enterpriseId = row.id
        state.exhibitorName = row.exhibitorName
        await initData()
        state.title = '设置类目分组'
        state.dialogFormVisible = true
      }

      const initData = async () => {
        const { data: hasChoose } = await queryExhibitorCategory({
          meetingEnterpriseId: state.enterpriseId,
        })
        const { data } = await queryCategoryConfigList({
          enterpriseGroupId: props.groupId,
        })
        if (data) {
          data.forEach((v) => {
            state.form[`formItem${v.id}`] = []
            v.prop = `formItem${v.id}`

            // 更新逻辑
            state.rules[v.prop] = [
              {
                required: true,
                message: `请选择${v.name}`,
                trigger: 'blur',
              },
            ]
          })

          if (hasChoose.length > 0) {
            hasChoose.forEach((v) => {
              state.form[`formItem${v.categoryGroupId}`].push(v.categoryId)
            })
          }
          console.log(data, state.rules, state.form)
          state.allCategoryList = data
        }
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false

        state.formRef.resetFields()
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = () => {
        state.formRef.validate(async (valid) => {
          if (valid) {
            try {
              let addExhibitorCategoryListBos = []
              state.allCategoryList.forEach((v) => {
                v.exhibitorSearchCategoryConfigVos.forEach((sitem) => {
                  if (state.form[v.prop].includes(sitem.id)) {
                    addExhibitorCategoryListBos.push({
                      categoryGroupId: v.id,
                      categoryId: sitem.id,
                    })
                  }
                })
              })
              let params = {
                addExhibitorCategoryListBos,
                groupId: props.groupId,
                id: state.enterpriseId,
              }
              await addOrUpdateExhibitorCategory(params)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
              handleClose()
              emit('fetchData')
            } catch (e) {
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
          }
        })
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleSelectionChange = (e) => {
        console.log(e)
        state.checkUserList = e
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleDate,
        handleSizeChange,
        handleCurrentChange,
        handleSelectionChange,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
